<div>
  <div class="v4-layout-form v4-layout-form-vertical" [formGroup]="form">
    <div class="v4-layout-field">
      <div
        class="v4-layout-field-label"
        [innerHTML]="'automation-edit_task_html_将创建' | translate: { property: detail?.property }">
        <!-- A Cleaning task will be created for <span class="text-c-d1 font-medium">{{ detail?.property }}</span> at -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <div class="w-1/2 pr-2">
            <nz-date-picker
              formControlName="plan_date"
              class="w-full"
              nzSize="large"
              [nzFormat]="angularDateFormat"></nz-date-picker>
          </div>
          <div class="w-1/2 pl-2">
            <nz-time-picker
              formControlName="plan_time"
              class="w-full"
              nzSize="large"
              [nzFormat]="timeFormat"></nz-time-picker>
          </div>
        </div>
      </div>
    </div>

    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "automation-edit_task_html_分配者" | translate }}
        <!-- Assignee -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <host-select
            class="w-full"
            size="large"
            formControlName="assigned_person"
            placeholder="Select a member (optional)"
            [defaultValue]="null"
            [listOfOption]="optionsOfAssigner"></host-select>
          <!-- <textarea formControlName="content" nz-input rows="4"></textarea> -->
        </div>
        <!-- <div class="v4-layout-field-extra">
          <div class="w-[150px]">
            <host-quick-msg-picker (onSelect)="onSelectQuickMsg($event)"></host-quick-msg-picker>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <div class="footer flex flex-row items-center justify-between">
    <div>
      <a nz-button nzType="link" nzDanger (click)="onRemove()">
        {{ "automation-edit_message_html_移除" | translate }}
        <!-- Remove -->
      </a>
      <a class="ml-2" nz-button nzType="link" (click)="onClickEdit()">{{
        "automation-edit_message_html_编辑规则" | translate
      }}</a>
    </div>
    <div class="ml-auto">
      <button class="mr-3" nz-button nzSize="large" (click)="onExecuteImmediately()">
        {{ "automation-edit_task_html_立即创建" | translate }}
        <!-- Create now -->
      </button>
      <button nz-button nzType="primary" nzSize="large" (click)="onSave()">
        {{ "word.save" | translate }}
        <!-- Save -->
      </button>
    </div>
  </div>
</div>
